import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import domClass from 'dojo/dom-class';
import template from './ThemeToggler.html?raw';


type Theme = "light" | "dark" | "auto";
class ThemeToggler extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private btnAuto: HTMLElement;
    private btnDark: HTMLElement;
    private btnBright: HTMLElement;

    private _isMainWindowInstance: boolean = false;


    private _updateThemeToggleStyle() {
        try {
            let isDark = false;
            let isLight = false;
            let isAuto = false;
            let state = this.getTheme();
            if (state == "auto") {
                isAuto = true;
                state = this.getTheme(true);
            }

            if (state == "dark" || state == "light") {
                isDark = state == "dark";
                isLight = state == "light";
            }

            
            this.UiModder.domClass.toggle(this.btnBright, "primaryBG primaryOutline", isLight && !isAuto);
            this.UiModder.domClass.toggle(this.btnDark, "primaryBG primaryOutline", isDark && !isAuto);
            //hoverBright
            this.UiModder.domClass.toggle(this.btnBright, "hoverBright", isDark || isAuto);
            this.UiModder.domClass.toggle(this.btnDark, "hoverBright", isLight || isAuto);

            this.hideNode(this.btnAuto, !this._hasDark() || !this._hasLight());
            this.UiModder.domClass.toggle(this.btnAuto, "primaryBG primaryOutline", isAuto == true);
            this.UiModder.domClass.toggle(this.btnAuto, "hoverBright", !isAuto);

            //domClass.toggle(this.btnToggleTheme, "cL4", isDark);
            //domClass.toggle(this.btnToggleTheme, "cD4", !isDark);

            //this.UiModder.domClass.toggle(this.btnDark, "hoverBright", !isDark);
            //this.UiModder.domClass.toggle(this.btnBright, "hoverBright", isDark);

            //this.btnDark.setReadonly(isDark);
            //this.btnBright.setReadonly(!isDark);

            //domClass.toggle(this.containerBrightMode, "w3-opacity-max", !isDark);
            //domClass.toggle(this.containerBrightMode, "w3-opacity-max", !isDark);
            //domClass.toggle(this.containerDarkMode, "w3-opacity-max", isDark);

        } catch (ex) {

        }

    }
    private _onClick_ToggleTheme(evt: MouseEvent) {
        this._toggleTheme();
    }
    private _onClick_DarkTheme(evt: MouseEvent) {
        
        this.setTheme("dark");
    }
    private _onClick_LightTheme(evt: MouseEvent) {
        this.setTheme("light");
    }

    _onClick_AutoTheme(evt: PointerEvent) {
        evt.stopPropagation();
        evt.preventDefault();
        
        this.setTheme("auto");
    }

    private _onSessionChange(data) {

        if (window.sessionInfo?.isSessionOpen()) {

            let currentTheme = this.getTheme(true);
            let storedTheme = this.getTheme();


            this.setTheme(storedTheme);
        }
    }

    private _onThemeChange(data) {
        //console.debug(this.is + " _onThemeChange", data);
        this._updateThemeToggleStyle();

    }

    private _osPrefersDark(): boolean {
        return window.matchMedia?.("(prefers-color-scheme: dark)").matches;
    }

    private _hasLight(bTrueIfNoDarkmode?: boolean): boolean {
        let light = this.hasFeature("System/lightMode");
        

        if (!light && bTrueIfNoDarkmode == true) {
            if (!this._hasDark()) {
                return true;
            }
        }

        return light;
    }


    private _hasDark(): boolean {
        if (this.hasUserRole("_DEV")) {
            return true;
        }
        return this.hasFeature("System/darkMode");
    }


    private _init() {
        let currentState: Theme = "auto";
        let hasLight = this._hasLight();
        let hasDark = this._hasDark();

        this._isMainWindowInstance = this.id && window.themeToggler && window.themeToggler.id == this.id;

        // es gibt eine Instanz auf window.themeToggler, aber es kann im Template auch mal eines eingebettet sein.
        // das am window kümmert sich um ein paar Sachen mehr
        if (this._isMainWindowInstance) {
            this.addSubscription("Theme/RequestChange", lang.hitch(this, this._onChangeRequest));

            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', lang.hitch(this, this._onOsThemeChange));

            if (!hasLight && !hasDark) hasLight = true;

            if (hasLight && hasDark) topic.publish("Theme/ToggleAvailable");

            currentState = this.getTheme(true);

            let targetState: Theme = currentState;

            if (currentState == "dark" && !hasDark) targetState = "light";
            else if (currentState == "light" && !hasLight) targetState = "dark";

            this._setTheme(targetState);
            this.checkApril1st();

        }
        //
        else {
            if (hasLight && hasDark) {

            } else {
                this.hideNode(this.domNode);
                setTimeout(lang.hitch(this, this.UiModder.domConstruct.destroy, this.domNode, 300));
                setTimeout(lang.hitch(this, this.destroy, 500));
                return;
            }
            currentState = this.getTheme();

            this._updateThemeToggleStyle();
        }

    }

    private _onOsThemeChange(evt) {
        

        if (this.getTheme() == "auto") {
            //let newColorScheme: Theme = evt.matches ? "dark" : "light";
            this.setTheme("auto");
        }
    }

    private checkApril1st() {

        if (!this.hasFeature("System/enableApril1st")) {
            return;
        }
        let now = new Date();
        let day = now.getDate();
        let month = now.getMonth() + 1;

        if (day == 1 && month == 4 ) {
            this.UiModder.domClass.add(document.body, "april1st");
        }
    }

    private _onChangeRequest(target?: string) {
        if (!target) {
            this._toggleTheme();
        } else {

        }
    }

    private _toggleTheme() {
        try {
            let currentState = this.getTheme();
            let actualState = this.getTheme(true);
            
            let targetState = currentState == "light" ? "dark" : "light";
            if (currentState == "auto") {
                targetState = actualState == "light" ? "dark" : "light";
            }

            this._setTheme(targetState as any);
        } catch (ex) {

        }
    }
    setTheme(target: Theme) {
        this._setTheme(target);
    }
    isDarkTheme(actualVisibleTheme?: boolean): boolean {
        return this.getTheme(actualVisibleTheme) == "dark";
    }
    getTheme(actualVisibleTheme?: boolean): Theme {
        let currentState: Theme = null;

        if (actualVisibleTheme === true) {
            let isDark = this.UiModder.domClass.contains(document.documentElement, "darkTheme");
            return isDark ? "dark" : "light";
        }
        
        try {
            let storageData = this._getStorageData();
            let userId = this.getCurrentUserId(null, true);

            

            if (!userId) {
                if (this._hasDark() && this._hasLight()) {
                    currentState = "auto";
                }

                userId = "_shared";
            }

            if (storageData && typeof (storageData) == "object") {
                let value = storageData[userId]
                if (value === "light" || value === "dark" || value === "auto")  currentState = value;
            }


        } catch (ex) {

        }

        let hasLight = this._hasLight();
        let hasDark = this._hasDark();

        if (!hasLight && !hasDark) hasLight = true;

        if (!hasLight) currentState = "dark";
        if (!hasDark) currentState = "light";
        
        return currentState;
    }
    private _setTheme(targetTheme: Theme) {
        let hasLight = this._hasLight(true);
        let hasDark = this._hasDark();
        let actualTheme: "dark" | "light" = targetTheme as any;

        

        if (targetTheme == "auto") {
            actualTheme = this._osPrefersDark() ? "dark" : "light";
        } else {
            
        }

        if (!hasLight && !hasDark) hasLight = true;

        if (actualTheme == "light" && !hasLight) return;
        if (actualTheme == "dark" && !hasDark) return;

        try {
            let metaElements = document.getElementsByName("color-scheme");
            let metaElement = metaElements?.length ? metaElements[0] : null;
            if (!metaElement) {
                metaElement = document.createElement("meta");
                this.UiModder.domAttr.set(metaElement, "name", "color-scheme");
                this.UiModder.domAttr.set(metaElement, "content", "light");
                document.head.appendChild(metaElement);

            }
            this.UiModder.domAttr.set(metaElement, "content", actualTheme == "dark" ? "dark" : "light");
        } catch (ex) {
            console.warn("meta-element for color-scheme failed", ex);
        }

        domClass.toggle(document.body, "darkTheme", actualTheme == "dark");
        domClass.toggle(document.documentElement, "darkTheme", actualTheme == "dark");

        // neues Format! Objekt mit der UserId als property und dem Wert dahinter
        let storageData = this._getStorageData();
        let userId = this.getCurrentUserId(null, true);
        if (!userId) userId = "_shared";
        storageData[userId] = targetTheme;
        storageData["_shared"] = targetTheme; // immer auch aufs shared speichern - wenn wer ohne Login draufschaut, bekommt er das als letzte Einstellung
        this._saveStorageData(storageData);

        topic.publish("Theme/Change", targetTheme);

        this._updateThemeToggleStyle();
    }

    private _getStorageData(): Object {
        let data: Object = null;
        
        try {
            let strValue = localStorage.getItem("ego_Darktheme");
            if (strValue) {
                if (strValue === "light" || strValue === "dark" || strValue == "auto") {
                    data = { "_shared": strValue };

                } else {
                    try {
                        let storageObj = JSON.parse(strValue);
                        data = storageObj;
                    } catch (ex) {

                    }
                }
            }
        } catch (ex) {

        }

        let defaultTheme: Theme = "light";

        let hasLight = this._hasLight();
        let hasDark = this._hasDark();

        if (hasLight && hasDark) defaultTheme = "auto";

        //if (this._osPrefersDark() && hasDark) defaultTheme = "dark";

        if (!hasLight && hasDark) defaultTheme = "dark";

        

        if (!data) {
            data = { "_shared": defaultTheme };
        }

        let userId = this.getCurrentUserId(null, true);
        if (!userId) userId = "_shared";

        if (!data.hasOwnProperty(userId)) {
            data[userId] = defaultTheme;
        }

        return data;
    }

    private _saveStorageData(data: Object) {
        if (!data) return;

        localStorage.setItem("ego_Darktheme", JSON.stringify(data));
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);



        this.addSubscription("Theme/Change", lang.hitch(this, this._onThemeChange));
        this.addSubscription("/Session/NewSession", lang.hitch(this, this._onSessionChange));

    }

    destroy() {
        super.destroy.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this._init();
    }
}

export default mdsWidget(ThemeToggler);
